<template>
    <router-view></router-view>
</template>

<script>
export default {
  name: "SkupStavkaBase"
};
</script>

<style scoped>

</style>
